// eslint-disable-next-line no-unused-vars
const  EgeTableHeaders = (_this) => {
    return {
    countCells: 7,
    massive: [
        {
            dataField: 'sortOrder',
            cols: 1,
            rows: 1,
            text: 'Приоритетность ВИ',
            order: 0,
            variable: true,
            // headerStyles: 'max-width: 50px;',
            // styles: 'min-width: 50px;',
        },
        {
            dataField: 'orgName',
            cols: 1,
            rows: 1,
            text: 'Наименование организации / филиала',
            order: 1,
            variable: true,
            headerStyles: 'min-width: 250px;',
            styles: 'min-width: 250px;',
            template: (row) => {
                return row.orgName;
            }
        },
        {
            dataField: 'isEge',
            cols: 1,
            rows: 1,
            text: 'Форма вступительных испытаний',
            order: 2,
            variable: true,
            template: row => {
                return row['isEge'] ? "ЕГЭ" : "Дополнительные ВИ"
            }
        },
        {
            dataField: 'challengeSubjectBalls',
            cols: 1,
            rows: 1,
            text: 'Предметы вступительных испытаний',
            order: 2,
            headerStyles: 'min-width: 250px;',
            styles: 'min-width: 250px;',
            variable: true,
            template: (row) => {
                return row['isEge'] ? row['challengeSubjectBalls'].map(el => {return  el.eduSubject.name}).join(' / ') : row['customEduSubjectName'];
            }
        },
        {
            dataField: 'ballMin',
            cols: 1,
            rows: 1,
            text: 'Минимальные баллы установленные по указанным предметам',
            order: 2,
            variable: true,
            template: row => {
                if (row['isEge']){
                   const arr =  row['challengeSubjectBalls'];
                   return arr && arr.length > 0 ? arr.map(el => {return  el.ballMin}).join(' / ') : 0
                }
                else
                    return row['ballMin'];
            }
        },
        {
            dataField: 'ballMinSpecific',
            cols: 1,
            rows: 1,
            text: 'Минимальные баллы для использования особого права',
            order: 2,
            variable: true,
            template: row => {
                if (row['isEge']){
                    const arr =  row['challengeSubjectBalls'];
                    return  arr &&  arr.length > 0 ? arr.map(el => {return  el.ballMinSpecific}).join(' / ') : 0
                }
                else
                    return row['ballMinSpecific'];
            }
        },
        {
            dataField: 'actions',
            cols: 1,
            rows: 1,
            text: 'Действия',
            order: 7,
            variable: true,
        },
    ],
    dialog: [
        {
            dataField: 'isEge',
            text: 'Форма вступительных испытаний',
            order: 3,
            typeVar: "customSelector",
            rules: 'customRules',
            customsRulesArray: [
                v=> (v !== false || v !== true) || 'Выберите форму ВИ'
            ],
            data: [
                {
                    "value": false,
                    "text": "Дополнительные ВИ"
                },
                {
                    "value": true,
                    "text": "ЕГЭ"
                },
            ],
        },
        {
            text: 'Предметы вступительных испытаний',
            dataField: "challengeSubjectBalls",
            variableName: 'challengeSubjectBalls',
            sprDataName: 'sprPredmet',
            multiple: true,
            dependence: true,
            dependenceDataField: "isEge",
            dependenceValueActive: [true],
            typeVar: "selector",
            emits: true,
            rules: 'customRules',
            customsRulesArray: [
                v => v != null || 'Значение должно быть выбрано'
            ],
            order: 4,
        },
        {
            text: "Предметы вступительных испытаний",
            dataField: "customEduSubjectName",
            typeVar: "string",
            dependence: true,
            dependenceDataField: "isEge",
            dependenceValueActive: [false],
            rules: 3,
            order: 4,
        },
        {
            text: "Минимальные баллы установленные по указанным предметам",
            dataField: "ballMin",
            typeVar: "integer",
            rules: 'customRules',
            dependence: true,
            dependenceDataField: "isEge",
            dependenceValueActive: [false],
            customsRulesArray: [
                // v => v >= _this.minValue || `Значение не может быть меньше минимального кол-ва баллов егэ ${_this.minValue}`,
                v => (v != null || v != 0) || 'Значение должно быть > 0',
                v => v<= 100 || 'Значение должно быть < 100',
            ],
            order: 5,
        },
        {
            text: "Минимальные баллы для использования особого права",
            dataField: "ballMinSpecific",
            typeVar: "integer",
            rules: 'customRules',
            dependence: true,
            dependenceDataField: "isEge",
            dependenceValueActive: [false],
            customsRulesArray: [
                // v => v >= 75 || `Значение не может быть меньше 75`,
                // v => (v != null || v != 0) || 'Значение должно быть заполнено',
                v => v<= 100 || 'Значение должно быть <= 100',
            ],
            order: 6,
        },
    ]
}
}
export default EgeTableHeaders